import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WarningNoteProps {
  children: ReactNode;
  /** Hover explanation when the sentence itself has to stay short. */
  title?: string;
  className?: string;
}

/**
 * A caution the person actually has to be able to read.
 *
 * `--warning` sits at ~3.2:1 on white: enough for a glyph (WCAG 1.4.11) and
 * short of the 4.5:1 that ARCHITECTURE §8 promises for *all* text. So the
 * triangle carries the hue and the sentence keeps the foreground ink — the
 * state is still signalled by shape and words, never by colour alone.
 */
export function WarningNote({ children, title, className }: WarningNoteProps) {
  return (
    <span
      {...(title ? { title } : {})}
      className={cn('inline-flex items-start gap-1.5 text-foreground', className)}
    >
      <TriangleAlert className="mt-0.5 size-3.5 shrink-0 text-warning" aria-hidden />
      <span>{children}</span>
    </span>
  );
}
